import { styled } from 'baseui'
import { MOBILE_BREAKPOINT_PX, MOBILE_MEDIA_QUERY } from '@/constants/responsive'

/** Phone layout for the premium and What's New dialogs; desktop styles stay as designed. */
export const COMPACT_MODAL_MEDIA = MOBILE_MEDIA_QUERY
/** The same breakpoint, for matchMedia checks. */
export const COMPACT_MODAL_QUERY = `screen and (max-width: ${MOBILE_BREAKPOINT_PX}px)`

/** Longhands, so a $style merge replaces WrapAutoScroll's padding longhands key by key. */
export function paddingLonghands(top: number, right: number, bottom: number, left: number) {
  return { paddingTop: `${top}px`, paddingRight: `${right}px`, paddingBottom: `${bottom}px`, paddingLeft: `${left}px` }
}

/** Phones show one full-screen column: the main step content, scrolled as one page. */
export const COMPACT_PRIMARY_COLUMN_STYLE = {
  width: '100%',
  height: 'auto',
  flexShrink: 0,
  overflowX: 'visible',
  overflowY: 'visible',
  marginRight: 0,
  ...paddingLonghands(56, 20, 32, 20),
} as const

/** Video or artwork becomes a banner above the copy. */
export const COMPACT_MEDIA_BANNER_STYLE = {
  width: '100%',
  height: 'min(40dvh, 320px)',
  flexShrink: 0,
  order: -1,
} as const

export const TwoColumnModalFrame = styled('div', {
  width: '100vw',
  height: '100vh',
  maxWidth: '920px',
  maxHeight: '652px',
  minWidth: '920px',
  minHeight: '652px',
  flexDirection: 'row',
  background: 'rgba(255, 255, 255, 1)',
  borderRadius: '16px',
  overflow: 'hidden',
  position: 'absolute',
  display: 'flex',
  // Pinned to the viewport edges rather than sized in viewport units, so the
  // frame is never taller than the screen and scrolls only when its content is.
  [COMPACT_MODAL_MEDIA]: {
    position: 'fixed',
    inset: 0,
    width: 'auto',
    minWidth: 0,
    maxWidth: 'none',
    height: 'auto',
    minHeight: 0,
    maxHeight: 'none',
    borderRadius: 0,
    flexDirection: 'column',
    overflowY: 'auto',
    overscrollBehavior: 'contain',
  },
})

/** Stays reachable while the stacked frame scrolls on phones. */
export const ModalCloseButton = styled('div', {
  position: 'absolute',
  top: '16px',
  right: '16px',
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  [COMPACT_MODAL_MEDIA]: {
    position: 'fixed',
    top: '12px',
    right: '12px',
    width: '40px',
    height: '40px',
    zIndex: 2,
  },
})
